import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as HeaderActions from '../actions/Header';
import Adl from '../components/Adl';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    moffAPI: state.moffAPI,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Adl as any);



// WEBPACK FOOTER //
// ./src/containers/Adl.tsx